import { useTranslation } from "react-i18next";
import type { Severity } from "../../master-data/api";

/**
 * Severity name with an optional colour dot from `colorHint`. The name is always
 * present, so the colour stays a supporting cue rather than the only signal.
 */
export function SeverityLabel({
  severity,
}: {
  severity: Severity | undefined;
}): JSX.Element {
  const { t } = useTranslation();

  if (!severity) {
    return <span className="text-muted-foreground">{t("common.none")}</span>;
  }

  return (
    <span className="inline-flex items-center gap-1.5">
      {severity.colorHint ? (
        <span
          className="inline-block h-2.5 w-2.5 rounded-full ring-1 ring-black/10"
          style={{ backgroundColor: severity.colorHint }}
          aria-hidden
        />
      ) : null}
      <span>{severity.name}</span>
    </span>
  );
}
